import {
  IField,
  IFormDocument,
  IListFilterBinder,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { TypedControlBase } from '../typed-controls';

export interface ListFilterControlWithValue extends TypedControlBase {
  readonly control: IListFilterBinder;
  readonly type: 'listfilter';
  value?: string[] | string;
}

/**
 * Map control metadata to typed object
 *
 * @param field - field metadata
 * @param doc
 */
export function getTypeControlsForListFilter(
  field: IField,
  doc: IFormDocument,
): ListFilterControlWithValue[] {
  const filters: ListFilterControlWithValue[] = DocHelper.getArrayWrapperValue(
    field.listfilter,
  ).map<ListFilterControlWithValue>(
    filter =>
      ({
        control: filter,
        type: 'listfilter',
        value: DocHelper.getFilterValue(filter, doc),
      } as ListFilterControlWithValue),
  );

  // @TODO i.ablov parse list controls here!
  return filters;
}
